module.exports = __webpack_public_path__ + "img/92209.4f4b603a.svg";